module.exports = __webpack_public_path__ + "img/placeholder.4232a727.jpg";